import React from 'react';
import PropTypes from 'prop-types';
import NoSSR from 'Components/NoSSR';
import { decimalFormatter } from 'Utils/decimalFormatter';
import { format } from 'date-fns';
import tr from 'date-fns/locale/tr';
import { useSelector } from 'react-redux';
import { classnames } from 'Utils/classnames';
import { PROGRAM_TYPES } from 'Store/constants/horseRacing';

const HorseRacingBetSlipHeader = ({ toggleBetSlip, selectedHippodrome }) => {
  
  const { isAuthenticated, data: { balance } } = useSelector(state => state.auth);
  const programType = useSelector(state => state.horseRacing.allHippodromes.programType);

  const prepareDate = () => {
    if (selectedHippodrome?.raceDate) {
      try {
        return format(new Date(selectedHippodrome?.raceDate), 'dd MMMM', { locale: tr });
      } catch (error) {
        return selectedHippodrome?.raceDate;
      }
    }
    return '';
  };


  return (
    <div className="horse-racing-betslip__header">
      <NoSSR>
        <div className="horse-racing-betslip__header__balance">
          { isAuthenticated && (
            <React.Fragment>
              <div className="horse-racing-betslip__header__balance__text">Bakiye</div>

              <div className="horse-racing-betslip__header__balance__value">
                { `${decimalFormatter(balance)} TL` }
              </div>
            </React.Fragment>
          ) }
        </div>
      </NoSSR>
      <div className={ classnames({
        'horse-racing-betslip__header__hippodrome-info': true,
        'horse-racing-betslip__header__hippodrome-info--no-auth': !isAuthenticated
      }) }>
        { programType === PROGRAM_TYPES.JOINT && <>
        { selectedHippodrome?.name ?? '' }
        <div>{ prepareDate() }</div>
      </> }
      </div>

      <div className="horse-racing-betslip__header__close-button" onClick={ toggleBetSlip }>
        <div className='horse-racing-betslip__header__close-button-wrapper'>
          <div className="horse-racing-betslip__header__close-button__text">Kapat</div>

          <i
            className="bly bly-caret-down bly-size10 horse-racing-betslip__header__close-button__arrow"
          />
        </div>

      </div>
    </div>
  );
};

HorseRacingBetSlipHeader.propTypes = {
  toggleBetSlip: PropTypes.func.isRequired,
  selectedHippodrome: PropTypes.object,
};

export default HorseRacingBetSlipHeader;
